import React, { useState } from "react";
import { Button, FormField, FormGroup, Input, Modal, ModalActions, ModalContent, ModalHeader, TextArea } from "semantic-ui-react";
import { createProduct } from "../../../services/products.service";
import { toast } from "react-toastify";

interface CreateProductModalProps {
    open: boolean;
    onClose: () => void;
    onRefreshData: () => void;
}

const CreateProductModal = ({ open, onClose, onRefreshData }: CreateProductModalProps) => {

    const [isSubmitting, setIsSubmitting] = useState(false);

    const [productData, setProductData] = useState({
        sku: "",
        name: "",
        description: "",
        productionTimeMin: "",
        productionTimeMax: "",
        reminderTime: "",
    });

    const handleChange = (e: any, { name, value }: any) => {
        setProductData({
            ...productData,
            [name]: value,
        });
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const response = await createProduct(productData);

            if (response?.status === 201) {
                // Refresh the data from parent component
                setProductData({
                    sku: "",
                    name: "",
                    description: "",
                    productionTimeMin: "",
                    productionTimeMax: "",
                    reminderTime: "",
                });
                onClose();
                onRefreshData();
                toast.success("Producto creado exitosamente");
            } else {
                throw new Error("Recurso no creado exitosamente");
            }
        } catch (error: any) {
            toast.error(error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <ModalHeader>Nuevo Producto</ModalHeader>
            <ModalContent>

                <div className="ui form">
                    <FormGroup>
                        <FormField
                            width={4}
                            control={Input}
                            label="Codigo"
                            placeholder="SKU"
                            name="sku"
                            value={productData.sku}
                            onChange={handleChange}
                            required
                        />
                        <FormField
                            width={12}
                            control={Input}
                            label="Nombre"
                            placeholder="Nombre descriptivo del producto"
                            name="name"
                            value={productData.name}
                            onChange={handleChange}
                            required
                        />
                    </FormGroup>

                    <FormGroup widths={"equal"}>
                        <FormField
                            control={Input}
                            type="number"
                            label="Tiempo minimo de produccion"
                            placeholder="Tiempo minimo de produccion en dias. ej. 7"
                            name="productionTimeMin"
                            value={productData.productionTimeMin}
                            onChange={handleChange}
                            required
                        />
                        <FormField
                            control={Input}
                            type="number"
                            label="Tiempo maximo de produccion"
                            placeholder="Tiempo maximo de produccion en dias. ej. 7"
                            name="productionTimeMax"
                            value={productData.productionTimeMax}
                            onChange={handleChange}
                            required
                        />
                        <FormField
                            control={Input}
                            type="number"
                            label="Dias para recodatorio"
                            placeholder="Dias para lanzar recodatorio anticipado. ej. 7"
                            name="reminderTime"
                            value={productData.reminderTime}
                            onChange={handleChange}
                            required
                        />
                    </FormGroup>

                    <FormField
                        control={TextArea}
                        label="Descripcion"
                        placeholder="Breve descripcion del producto..."
                        name="description"
                        value={productData.description}
                        onChange={handleChange}
                    />
                </div>

            </ModalContent>
            <ModalActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button color="blue" onClick={handleSubmit} loading={isSubmitting}>Guardar</Button>
            </ModalActions>
        </Modal>
    );
};

export default CreateProductModal;